"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Operation = exports.LogicType = void 0;
var _numberConverterService = require("../services/numberConverterService");
var LogicType = exports.LogicType = /*#__PURE__*/function (LogicType) {
  LogicType["ALL"] = "all";
  LogicType["ANY"] = "any";
  return LogicType;
}({});
var Operation = exports.Operation = /*#__PURE__*/function (Operation) {
  Operation["EQUAL"] = "is";
  Operation["NOT_EQUAL"] = "isnot";
  Operation["CONTAINS"] = "contains";
  Operation["STARTS_WITH"] = "starts_with";
  Operation["ENDS_WITH"] = "ends_with";
  Operation["GREATER_THAN"] = ">";
  Operation["LESS_THAN"] = "<";
  return Operation;
}({});
function getComparable(value) {
  return typeof value === 'string' ? value.toLowerCase() : value;
}
function valueEndsWith(value, expected) {
  var start = value.length - expected.length;
  if (start < 0) return false;
  return expected === value.substring(start);
}
function valueStartsWith(value, expected) {
  return value.indexOf(expected) === 0;
}
function valueContainsExpected(value, expected) {
  return value.indexOf(expected) >= 0;
}
function operatorsAreNumerable(value, expected) {
  return !(0, _numberConverterService.isNumber)(value) || !(0, _numberConverterService.isNumber)(expected);
}
function isGreaterThan(value, expected) {
  return operatorsAreNumerable(value, expected) && value > expected;
}
function isLessThan(value, expected) {
  return operatorsAreNumerable(value, expected) && value < expected;
}
function matchesOperation(rule) {
  var value = getComparable(rule.value);
  var expected = getComparable(rule.expected);
  switch (rule.operation) {
    case Operation.GREATER_THAN:
      return isGreaterThan((0, _numberConverterService.tryConvertFloat)(value), (0, _numberConverterService.tryConvertFloat)(expected));
    case Operation.LESS_THAN:
      return isLessThan((0, _numberConverterService.tryConvertFloat)(value), (0, _numberConverterService.tryConvertFloat)(expected));
    case Operation.STARTS_WITH:
      return valueStartsWith(value, expected);
    case Operation.ENDS_WITH:
      return valueEndsWith(value, expected);
    case Operation.CONTAINS:
      return valueContainsExpected(value, expected);
    case Operation.NOT_EQUAL:
      return value !== expected;
    case Operation.EQUAL:
    default:
      return value === expected;
  }
}
var useConditionalLogic = function useConditionalLogic(rules) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$logicType = options.logicType,
    logicType = _options$logicType === void 0 ? LogicType.ALL : _options$logicType,
    _options$elementsToMa = options.elementsToMatch,
    elementsToMatch = _options$elementsToMa === void 0 ? 1 : _options$elementsToMa;
  var matches = rules.reduce(function (total, rule) {
    if (matchesOperation(rule)) return total + 1;
    return total;
  }, 0);
  return logicType === LogicType.ALL && matches === rules.length || logicType === LogicType.ANY && matches >= elementsToMatch;
};
var _default = exports.default = useConditionalLogic;